import util   from '../../common/AppUtil';

const ServerMode = 0;
const ApiCode = "XData";

export default {
  getListPage: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"list");
  },

  removeRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"del");
  },

  addRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"add");
  },

  saveRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"save");
  },

  getRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"get");
  }
}
  


// WEBPACK FOOTER //
// ./src/api/system/xdata.js